import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {denim} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  buttonsContainer: {
    flexDirection: 'column',
    justifyContent: 'flex-end',
    paddingVertical: indent / 2,
    marginTop: indent / 2,
  },
  title: {
    paddingHorizontal: indent / 2,
    textAlign: 'left',
    fontSize: 14,
  },
  description: {
    marginTop: indent,
    paddingHorizontal: indent / 2,
    textAlign: 'left',
    fontSize: 14,
  },
  discardButton: {
    marginBottom: indent / 2,
    backgroundColor: denim,
    borderRadius: 5,
  },
  cancelButton: {
    borderRadius: 5,
  },
  container: {
    paddingBottom: indent / 2,
    paddingTop: indent * 1.5,
    paddingHorizontal: indent,
  },
  split: {
    width: indent * 0.75,
  },
  headerContainer: {
    flexDirection: 'row',
  },
  popupText: {
    width: '95%',
  },
  actionIcon: {
    fontSize: 20,
  },
});
